$(function () {
  $('#model-slider').slick({
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    prevArrow: '<div class="model-slider-arrows model-slider-arrows--prev"><img src="../images/model/arrow--prev.png"></div>',
    nextArrow: '<div class="model-slider-arrows model-slider-arrows--next"><img src="../images/model/arrow--next.png"></div>',
    dots: true,
    dotsClass: 'model-slider-dots',
    speed: 2000,
    pauseOnFocus: false,
		pauseOnHover: false,
		pauseOnDotsHover: false,
    asNavFor: '#model-slider-thumb',
  });

  $('#model-slider-thumb').slick({
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 4,
    arrows: true,
    appendArrows: $('.model-slider-thumb-arrows'),
    prevArrow: '<div class="model-slider-thumb-arrows--prev"><img src="../images/model/arrow--prev.png"></div>',
    nextArrow: '<div class="model-slider-thumb-arrows--next"><img src="../images/model/arrow--next.png"></div>',
    speed: 2000,
    pauseOnFocus: false,
		pauseOnHover: false,
		pauseOnDotsHover: false,
    asNavFor: '#model-slider',
    focusOnSelect: true,
    

    responsive: [{
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        
      }
    }],
    
  });
});
